import React from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  FileText, Monitor, Map as MapIcon, Layers, Award, Pizza 
} from 'lucide-react';
import './BuildersHub.css';

const BuildersHub = ({ hiddenItems = [] }) => {
  const navigate = useNavigate();

  const builders = [
    {
      id: 'quiz',
      title: 'Квіз (Тести)',
      description: 'Створюйте текстові та мультимедійні тести з одиночним або множинним вибором, а також імпортуйте питання з Excel.',
      icon: <FileText size={32} />,
      path: '/quiz-builder',
      color: '#fbbf24'
    },
    {
      id: 'desk',
      title: 'Сервірування столу',
      description: 'Інтерактивний Drag-and-drop конструктор еталонної розстановки посуду, приборів та келихів на столах ресторану.',
      icon: <Monitor size={32} />,
      path: '/virtual-desk',
      color: '#3b82f6'
    },
    {
      id: 'dialogue',
      title: 'Візуальний редактор ігор',
      description: 'Конструктор розгалужених діалогів з гостями у вигляді дерева слів із налаштуванням лояльності та озвучки ElevenLabs.',
      icon: <MapIcon size={32} />,
      path: '/visual-builder',
      color: '#a855f7'
    },
    {
      id: 'complex',
      title: 'Комплексні тести',
      description: 'Об\'єднуйте раніше створені квізи, сервірування та рольові ігри у єдині великі атестаційні екзамени.',
      icon: <Layers size={32} />,
      path: '/complex-builder',
      color: '#10b981'
    },
    {
      id: 'certificates',
      title: 'Шаблони сертифікатів',
      description: 'Створюйте та кастомізуйте преміальні верифіковані дипломи з QR-кодами для нагородження кращих студентів.',
      icon: <Award size={32} />,
      path: '/certificates',
      color: '#e0f2fe'
    },
    {
      id: 'pizza-pairing',
      title: 'Конструктор піци',
      description: 'Створюйте інтерактивні тести на знання рецептур піци, основи, соусів та топінгів.',
      icon: <Pizza size={32} />,
      path: '/pairing-builder',
      color: '#f97316'
    }
  ];

  const visibleBuilders = builders.filter(b => {
    const mapping = {
      'quiz': 'quiz-builder',
      'desk': 'virtual-desk',
      'dialogue': 'visual-builder',
      'complex': 'complex-builder',
      'certificates': 'certificates',
      'pizza-pairing': 'pairing-builder'
    };
    const menuId = mapping[b.id] || b.id;
    return !hiddenItems.includes(menuId);
  });

  return (
    <div className="hub-container">
      <div className="hub-header">
        <h1>⚡ Інтерактивність</h1>
        <p>Керування навчальним контентом та інтерактивними тренажерами</p>
      </div>
      <div className="hub-grid">
        {visibleBuilders.map((b) => (
          <div key={b.id} className="hub-card" onClick={() => navigate(b.path)}>
            <div className="hub-card-icon" style={{ color: b.color, backgroundColor: `${b.color}15`, borderColor: `${b.color}30` }}>
              {b.icon}
            </div>
            <div className="hub-card-content">
              <h3 style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                {b.title}
                {b.isBeta && <span className="beta-badge">BETA</span>}
              </h3>
              <p>{b.description}</p>
            </div>
            <div className="hub-card-action">
              <span>Відкрити конструктор →</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BuildersHub;
